<template>
  <!-- need list headers  -->
  <div>
    <div class="row_">
      <div class="column_">
        <v-card class="hvh-card--rounded">
          <h2 class="patTableHeader"><strong>Incoming Patients</strong></h2>
          <v-layout>
            <v-flex xs12>
              <Loader v-if="isLoading" />
              <hvh-freeze-data-table v-else :class="{ disabled: false }" :headers="headers" :items="modelData.incoming_refs" :loading="false" />
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div class="column_">
        <v-card class="hvh-card--rounded">
          <h2 class="patTableHeader"><strong>Outgoing Patients</strong></h2>
          <v-layout>
            <v-flex xs12>
              <Loader v-if="isLoading" />
              <hvh-freeze-data-table v-else :class="{ disabled: false }" :headers="headers" :items="modelData.outgoing_refs" :loading="false" />
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios'
import { errorDebug } from '../../libraries/common';

export default {
  props: ['npi', 'runID', 'cohortId'],

  data() {
    var labels = {
      profileLink: { text: "Profile Link", route: "hcpProfile", params: { runId: this.runId, cohortId: 1 } },
      // NPI: "NPI",
      firstName: "First Name",
      lastName: "Last Name",
      specialty: "Specialty",
      numPats: "Number of Patients"
    };

    return {
      labels,
      isLoading: true,
      modelData: null // need toData & fromData, both are (Doctor doc, int numPats) tuples 
    };
  },
  methods: {
    getData() {
      // set the modeldata to the claims stuff here 
      this.isLoading = true;
      axios.get(`/HCPProfiles/${this.$route.params.cohortId}/SharedPatients/${this.$route.params.npi}`)
        .then(response => this.modelData = response.data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  computed: {
    headers() {
      // if (Object.keys(this.filterHeaders).length > 0){
      //     this.filterHeaders.profileLink = {text:"Profile Link",route:"hcpProfile"}
      // }
      var headers = Object.keys(this.filterHeaders).length ? this.filterHeaders : this.labels;
      var retVal = Object.keys(headers)
        .map(key => ({
          valueFnc: (item) => {try { return item[key]; } catch(e) { console.error(`Property - ${key}.`, e); }},

        //   valueFnc: new Function('item', `try { return item.${key}; } catch(e) { console.error('Property - ${key}.', e); }`),
          text: typeof (headers[key]) == 'string' ? headers[key] : headers[key].text,
          routeObj: typeof (headers[key]) == 'object' ? headers[key] : { text: "", route: "" },
          routeParamsFnc: item => {try { return {runId:this.$route.params.runId, cohortId:1, npi:item.npi}; } catch(e) { console.error('Property - ${key}.', e); }},

        //   routeParamsFnc: new Function('item', `try { return {runId:${this.$route.params.runId}, cohortId:1, npi:item.npi}; } catch(e) { console.error('Property - ${key}.', e); }`),
          link: typeof (headers[key]) == 'object' ? true : false,
          sortable: false
        }));

      var link = retVal.filter(f => f.text == 'Profile Link')
      var nonLink = retVal.filter(f => f.text != 'Profile Link')

      retVal = [...link, ...nonLink]
      return retVal;
    },
    filterHeaders() {
      var headers = this.labels;
      return Object.keys(headers)
        .filter(key => headers[key])
        .reduce((acc, key) => {
          acc[key] = headers[key];
          return acc;
        }, {});
    },
  },
  watch: {
    '$route.params.runId'() {
      this.getData()
    },
    '$route.params.npi'() {
      this.getData()
    },
    '$route.params.cohortId'() {
      this.getData()
    },
  },
  mounted() {
    this.getData();
  },
}

</script>

<style scoped>
* {
  box-sizing: border-box;
}

.patTableHeader {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
/* .row_ {
  margin-left:-5px;
  margin-right:-5px;
}

   */
.column_ {
  float: left;
  width: 50%;
  /* padding: 5px; */
}

/* Clearfix (clear floats) */
.row_::after {
  content: '';
  clear: both;
  display: table;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}

th,
td {
  text-align: left;
  padding: 16px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>